import React from 'react';
import { Component } from '../../../../../index';
import { ABOUT_LINK_DATA, ABOUT_PROPS } from './Types';

class About extends Component<ABOUT_PROPS> {
  /**
   * Creates link element from passed data.
   * @param data
   */
  getLink(data: ABOUT_LINK_DATA) {
    const { text, href, target } = data;
    return (
      <a
        href={href}
        target={target}
        className={'k-link tp-link'}
        key={Date.now() + text}
      >
        {text}
      </a>
    );
  }

  /**
   * Map items based on href parameter.
   * If href exist, item will become link element otherwise it will become span element.
   * @param link
   * @param index
   */
  mapItems = (link: ABOUT_LINK_DATA, index: number) => link.href ? this.getLink(link) : <span
    key={Date.now() + index}
  >
    {link.text}
  </span>;

  /**
   * Forms all rights reserved text and links.
   */
  allRightsReserved() {
    const links: ABOUT_LINK_DATA[] = [{
      href: this.translateByNamespace('url.translations'),
      text: this.translate('translations'),
      target: '_blank'
    }, {
      text: this.translate('allRightsReserved')
    }, {
      href: this.translateByNamespace('url.privacyPolicy'),
      text: this.translate('privacyPolicy'),
      target: '_blank'
    }];
    return (
      <span key={'allRightsReserved'}>
        {this.translate('copyrights', { date: new Date() })}
        {links.map(this.mapItems)}
      </span>
    );
  }

  /**
   * Forms app version info.
   */
  getAppVersion() {
    const { appVersion, appName } = this.props;
    return <p>{this.translate('appVersion', { appName, appVersion })}</p>;
  }

  /**
   * @inheritDoc
   */
  renderBody() {
    return (
      <div className={'tp-about-dialog-content'} key={'About' + Date.now()}>
        {this.getAppVersion()}
        &nbsp;
        {this.allRightsReserved()}
      </div>
    );
  }
}

export default About;
